import React from "react";

const NoMatchPage = () => (
  <a
    href="https://en.wikipedia.org/wiki/Houston,_we_have_a_problem"
    target="_blank"
    rel="noopener noreferrer"
  >
    <h1>
      Houston, we have a problem!
      <span role="img" aria-labelledby="face screaming in fear">
        {" "}
        😱😱😱
      </span>
    </h1>
  </a>
);

export default NoMatchPage;
